import { Flex } from "@chakra-ui/react";

const InfoCardWrap = ({ children }) => {
  return (
    <Flex
      w={"100%"}
      align={"start"}
      justifyContent={"space-between"}
      columnGap={"24px"}
      rowGap={"8px"}
      flexWrap={"wrap"}
    >
      {children}
    </Flex>
  );
};

export default InfoCardWrap;
